import React from 'react';
import './TablePage.css';

const SCHEDULE = [
  { label: 'D-7 (0일차)', desc: '전달 알림만', phase: 'NONE' },
  { label: 'D-6 (1일차)', desc: '힌트 공개', phase: 'HINT' },
  { label: 'D-4 (3일차)', desc: '메시지 1단 공개', phase: 'MESSAGE_1' },
  { label: 'D-2 (5일차)', desc: '메시지 2단 공개', phase: 'MESSAGE_2' },
  { label: 'D-1 (6일차)', desc: '메시지 3단 공개', phase: 'MESSAGE_3' },
  { label: 'D-day (7일차)', desc: '픽 기회 오픈', phase: 'FULL' },
];

export default function SettingsPage() {
  return (
    <div className="table-page">
      <h2>시스템 설정</h2>

      <div className="settings-section">
        <h3>점진 공개 스케줄</h3>
        <p className="settings-desc">현재 적용 중인 WEEK1 공개 스케줄입니다.</p>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>시점</th><th>내용</th><th>공개 단계</th></tr>
            </thead>
            <tbody>
              {SCHEDULE.map((s) => (
                <tr key={s.label}>
                  <td><strong>{s.label}</strong></td>
                  <td>{s.desc}</td>
                  <td><code>{s.phase}</code></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="settings-section">
        <h3>주요 타이밍 정책</h3>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>항목</th><th>값</th><th>설명</th></tr>
            </thead>
            <tbody>
              <tr><td>WEEK1 (점진 공개)</td><td>7일</td><td>D-7 ~ D-day</td></tr>
              <tr><td>WEEK2 (결과 대기)</td><td>7일</td><td>픽기회 사용 후 결과 발표까지</td></tr>
              <tr><td>보호 기간</td><td>30일</td><td>매칭 성사 후 양쪽 보호</td></tr>
              <tr><td>픽 만료</td><td>14일</td><td>미가입자 대기 포함</td></tr>
              <tr><td>야간 푸시 금지</td><td>01:00~07:00</td><td>야간 알림 발송 차단</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="settings-section">
        <p className="settings-desc">픽 상태/단계/날짜 강제 변경은 <strong>픽 관리 → 픽 상세</strong>에서 할 수 있습니다.</p>
      </div>
    </div>
  );
}
